import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('vehicle-list/index', {params});
    },
    show(id) {
        return Service().get('vehicle-list/show/'+id);
    },
    create(params) {
        return Service().post('vehicle-list/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('vehicle-list/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('vehicle-list/delete/'+id);
    },
    getVehicleByPlant(params) {
        return Service().get('vehicle-list/get-vehicle-by-plant', {params});
    },
}